import { openText } from '../constants';

export const isBannerOpen = ( element ) => {
	if ( element ) {
		if ( sessionStorage.getItem( element.getAttribute( 'id' ) ) === null ) {
			return 'firstVisit';
		}
		return sessionStorage.getItem( element.getAttribute( 'id' ) ) === openText;
	}
	return false;
};
export default isBannerOpen;
